import { getWaitlistStatusMockHandler } from '@/features/onboarding/components/step-tracker/api/waitlist-status/get-waitlist-status';

export const waitlistHandlers = [getWaitlistStatusMockHandler];
